export default __webpack_public_path__ + "static/media/refresh2.8bc6319c.png";